import { sortArray } from "components/results/analysis-results/sortUtil";
import { GroupTableType } from "helpers/models";

export default (groupData: GroupTableType) => {
  const sorted = Object.entries(groupData)
    .sort(([a], [b]) => {
      return sortArray.indexOf(a) - sortArray.indexOf(b);
    })
    .reduce((acc: GroupTableType, [key, val]) => {
      acc[key] = val;
      return acc;
    }, {});

  return sorted;
};
